import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { OrderStatus } from "./order-status";
import { ObjectLayer } from "./object-layer";
import { OrderProductType } from "./order-product-type";
import { OrderItemProductNonDoableFlag } from "./order-item-product-non-doable-flag";
import { OrderProcessingStack } from "./order-processing-stack";
import { CurrencyPriceInfos } from "./currency-price-infos";
import { DbOrderManualTaskTemplateInfos } from "./db-order-manual-task-template-infos";
import { OrderItemAck } from "./order-item-ack";
import { WarningDetail } from "./warning-detail";
import { DbIssueInfos } from "./db-issue-infos";
import { DbOrderProductInfos } from "./db-order-product-infos";
import { DbCustomerInfos } from "./db-customer-infos";
import { DbUserBasicInfos } from "./db-user-basic-infos";
import { DbFileTransferInfos } from "./db-file-transfer-infos";
import { DbActivityInfos } from "./db-activity-infos";
import { DbAssetObjectInfos } from "./db-asset-object-infos";
import { immerable } from "immer";

export class DbOrderItemInfos extends DbMongoSerializationBaseInfos {
  [immerable]: true;
  watermarking: boolean = false;
  isAutomatedPipeline: boolean = false;
  doable: boolean | null = false;
  priority: number | null = 0;
  platformId: number | null = 0;
  orderId: number = 0;
  ownerUserId: number | null = 0;
  productId: number | null = 0;
  objectId: number = 0;
  relatedTitleId: number = 0;
  slaPenality: number | null = 0;
  status: OrderStatus | null = null;
  objectLayer: ObjectLayer | null = null;
  type: OrderProductType = OrderProductType.AntipiracyInaSignature; // default is first of enum, always returned by backend
  creationTime: Date | null = null;
  summarizedInfos: string | null = null;
  objectName: string | null = null;
  message: string | null = null;
  contractExternalDealId: string | null = null;
  erpWorkOrderId: string | null = null;
  broadcasterId: number | null = 0;
  parentObjectId: number | null = 0;
  contentId: number | null = 0;
  startedByUserId: number | null = 0;
  transferSize: number | null = 0;
  customerId: number | null = 0;
  manualTasksTemplateId: number | null = 0;
  editedBy: number | null = 0;
  transferId: number | null = 0;
  attachedFileTransferId: number | null = 0;
  approvedByUserId: number | null = 0;
  nonDoableFlag: OrderItemProductNonDoableFlag | null = null;
  workflowRestoreDuration: string | null = null;
  workflowTranscodeDuration: string | null = null;
  workflowDeliverDuration: string | null = null;
  slaOutOfDuration: string | null = null;
  workflowDeliverStartTime: Date | null = null;
  workflowRestoreStartTime: Date | null = null;
  workflowRestoreEndTime: Date | null = null;
  playTime: Date | null = null;
  startTime: Date | null = null;
  updateTime: Date | null = null;
  endTime: Date | null = null;
  doableTime: Date | null = null;
  resumeDate: Date | null = null;
  nonDoableMissingAssetsTime: Date | null = null;
  nonDoableCandidateAssetsTime: Date | null = null;
  editedTime: Date | null = null;
  stack: OrderProcessingStack | null = null;
  price: CurrencyPriceInfos | null = new CurrencyPriceInfos();
  manualTasksTemplate: DbOrderManualTaskTemplateInfos | null = null;
  billingAck: OrderItemAck | null = null;
  followerUserIds: number[] | null = null;
  billingEmails: string[] | null = null;
  warningDetails: WarningDetail[] | null = null;
  includeOnlyAvailableValues: boolean | null = null;
  titleCustomerId: string | null = null;
  issues: DbIssueInfos[] | null = null;
  product: DbOrderProductInfos | null = null;
  customer: DbCustomerInfos | null = null;
  lockedBy: DbUserBasicInfos[] | null = null;
  locked: boolean | null = null;
  titleName: string | null = null;
  etaDate: Date | null = null;
  dueDate: Date | null = null;
  isSystem: boolean | null = null;
  deliveryNumberName: string | null = null;
  followersName: string[] | null = null;
  editorName: string | null = "";
  starterName: string | null = "";
  customerName: string | null = "";
  lockedByNames: string[] | null = [];
  ownerUserName: string | null = "";
  ownerUserGroupName: string | null = "";
  approvedByUserName: string | null = "";
  fileTransfer: DbFileTransferInfos | null = null;
  attachedFileTransfer: DbFileTransferInfos | null = null;
  activities: DbActivityInfos[] | null = null;
  color: string | null = null;
  objectInfos: DbAssetObjectInfos | null = null;

  constructor(init?: Partial<DbOrderItemInfos>) {
    super();
    this[immerable] = true;
    Object.assign(this, init);
  }
}
